const API_BASE = '/api';

export async function saveBudget(budget) {
  try {
    const response = await fetch(`${API_BASE}/save_budget.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(budget),
    });

    if (!response.ok) {
      const errorText = await response.text();
      // If we are in local dev (and PHP isn't running on the same port), this will likely fail with 404 or similar.
      // We can fallback to local storage or just throw.
      throw new Error(`Server error: ${response.status} ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.warn("API Call failed (expected in local dev without PHP):", error);
    // Optional: Fallback to local storage for dev
    console.log("Saving to localStorage instead for dev/demo purposes");
    const localBudgets = JSON.parse(localStorage.getItem('turia_budgets') || '[]');
    const newBudget = { ...budget, id: crypto.randomUUID(), savedAt: new Date().toISOString() };
    localBudgets.push(newBudget);
    localStorage.setItem('turia_budgets', JSON.stringify(localBudgets));
    return { success: true, id: newBudget.id, local: true };
  }
}

export async function getBudgets() {
  try {
    const response = await fetch(`${API_BASE}/get_budgets.php`);
    
    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    // Check content type to ensure we got JSON (sometimes PHP errors return HTML)
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
        // If we get HTML (e.g. 404 page or PHP error), treat as empty/error
       throw new Error("Received non-JSON response from server");
    }

    return await response.json();
  } catch (error) {
    console.warn("API Call failed (expected in local dev without PHP):", error);
     // Optional: Fallback to local storage
    const localBudgets = JSON.parse(localStorage.getItem('turia_budgets') || '[]');
    return localBudgets;
  }
}
